import { digitsEnToFa } from '@persian-tools/persian-tools';

export function persianNumber(n: number | string) {
  return digitsEnToFa(n);
}
